export const backgroundArtworks = [
  {
    artistName: 'Geneviève Vastrade',
    title: 'Untitled',
    year: '2022',
    asset: '/assets/artworks/Vastrade-1.jpg',
  },
  {
    artistName: 'Geneviève Vastrade',
    title: 'Untitled',
    year: '2022',
    asset: '/assets/artworks/Vastrade-2.jpg',
  },
  {
    artistName: 'Dawid Czycz',
    title: 'The Sunset for Cowboy',
    year: '2021',
    asset: '/assets/artworks/sunset-of-cowboy.jpg',
  },
];



// WEBPACK FOOTER //
// ./src/scenes/configs/backgroundArtworks.config.jsx